// extracted by mini-css-extract-plugin
export default {"container":"LottieAnimation_container__P9Nid","isLoaded":"LottieAnimation_isLoaded__Jpifd"};